
import { InterceptMiddle } from '../../regular';

/**
 * 矩阵填空 单元格求和
 * 1.MatrixSum[quesCode_rowsNum1_oprionNum1 = rowsNum1_oprionNum1:rowsNum4_optionNum3] // 计算rowsNum1_oprionNum1 至 rowsNum4_optionNum3 单元格中数字的和
 * 2.MatrixSum[quesCode_rowsNum1_oprionNum1 = rowsNum1_oprionNum1,rowsNum4_optionNum3] // 计算rowsNum1_oprionNum1 + rowsNum4_optionNum3 单元格中数字的和
 * 3.MatrixSum[quesCode_rowsNum1_oprionNum1 = rowsNum1_oprionNum1,rowsNum1_oprionNum1:rowsNum4_optionNum3] // 计算rowsNum1_oprionNum1 + rowsNum1_oprionNum1 至 rowsNum4_optionNum3 单元格中数字的和
 * @param item 目标单元格str
 * @param ques 当前试题
 */
export const MatrixSum = (item, ques) => {
    
    // 计算 矩阵填空中数值的和 MatrixSum[Q1_5_1 = 1_1:4_1]
    if (item.indexOf('=') == -1) return
    let str = item.replace(/\s/g,'').split('=')
    // 目标 试题编号
    let code = InterceptMiddle(str[0], ['MatrixSum['], ['_']) // 试题编号
    if (code != ques.quesCode) return
    let row = InterceptMiddle(str[0], ['_'], ['_']) // 行号
    let option = InterceptMiddle(str[0], [`_${row}_`], []) // 选项号
    let sum = getSum(InterceptMiddle(str[1], [], [']']), ques)
    Voluation(sum, ques.questionsSonList,row, option)
    return ques
}
/**
 * 获取选中的行个数
 * @param {string} str  
 * @param {Object} ques 
 * @returns 个数
 */
const getSum = (str, ques) => {
    // 1_1:4_1 1_1,4_1 1_1:1_1,4_1
    let result = 0
    let arr = str.split(',')
    arr.forEach((info) => {
        if (info.indexOf(':') != -1) {
            let newArr = info.split(':')
            let AtoBArr = []
            if (newArr.length != 2) return
            newArr.forEach((val) => {
                
                let row = InterceptMiddle(val, [], ['_']) // 行号
                let option = InterceptMiddle(val, [`${row}_`], []) // 选项号
                AtoBArr.push({row, option})
            })
            result += AtoB(AtoBArr, ques.questionsSonList)
        } else {
            let row = InterceptMiddle(info, [], ['_']) // 行号
            let option = InterceptMiddle(info, [`${row}_`], []) // 选项号
            result += AandB(row, option, ques.questionsSonList)
        }
    })
    return result
}

const AandB = (row, option, SonList) => {
    let result = 0
    SonList.forEach((val) =>{
        if (val.orderNum == row
            && val.type == '26'
        ) {
            val.optionList.forEach((info) => {
                if (info.orderNum == option 
                    && val.userAnswer
                    && val.userAnswer.indexOf(info.oid) != -1
                ) {
                    result++
                }
            })
        }
    })
    return result
}

const AtoB = (AtoBArr, SonList) => {
    let result = 0
    SonList.forEach((val) =>{
        if (val.orderNum >= AtoBArr[0].row 
            && val.orderNum <= AtoBArr[1].row 
            && val.type == '26'
        ) {
            val.optionList.forEach((info) => {
                if (info.orderNum >= AtoBArr[0].option 
                    && info.orderNum <= AtoBArr[1].option
                    && val.userAnswer
                    && val.userAnswer.indexOf(info.oid) != -1
                ) {
                    result++
                }
            })
        }
    })

    return result
}

/**
 * 赋值
 * @param {Number} sum
 * @param {Object} ques 
 */
export const Voluation = (sum, SonList, row, option) => {
    SonList = SonList.map((val) =>{
        // console.log('val.orderNum :>> ', val.orderNum, val.type);
        if (val.orderNum == row
            && (val.type == '1' || val.type == '2')
        ) {
            val.optionList = val.optionList.map((info) => {
                // console.log('info.orderNum :>> ', info.orderNum, option);
                if (info.orderNum == option) {
                    // console.log('sum :>> ', sum);
                    info.userAnswer = sum
                }
                return info
            })
        }
        return val
    })
    // console.log('SonList :>> ', SonList);
}